/**
 * BlueSolution Subscription Management API
 * Last changed: 2025-03-05T10:54:50+00:00
 *
 * OpenAPI spec version: 1.0.13
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { OneqrewModule } from '../model/oneqrewModule';
import { OneqrewProductPackage } from '../model/oneqrewProductPackage';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BssLegacyProductDiscount } from '../model/bssLegacyProductDiscount';

@Injectable()
export class LegacyService {
  protected basePath = '/';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   * Get all modules that are marked as extra
   *
   * @param maxResults Number of results that should be returned.
   * @param page Get results from this Page
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAllLegacyProductDiscounts(
    startOfContract?: Date,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<BssLegacyProductDiscount>>;
  public getAllLegacyProductDiscounts(
    startOfContract?: Date,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<BssLegacyProductDiscount>>>;
  public getAllLegacyProductDiscounts(
    startOfContract?: Date,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<BssLegacyProductDiscount>>>;
  public getAllLegacyProductDiscounts(startOfContract: Date, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (startOfContract !== undefined && startOfContract !== null) {
      const formatLocalDate = (date: Date): string => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
      };

      const formatted = formatLocalDate(startOfContract);
      queryParameters = queryParameters.set('startOfContract', formatted);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<OneqrewModule>>('get', `${this.basePath}/legacy-product-discounts/`, {
      params: queryParameters,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress
    });
  }
}
